import { TFormValues } from "../../../../../components/Form/types/form.types";
import { gateway } from "../../../../../gateway";

export const postSignUpAction = async (data: TFormValues) => {
    const response = await gateway.post("/users/flownect", data);
    return response.data || response.data?.data;
}